export default "__VITE_ASSET__eb012e37__"